var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.label ? _c('p', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _c('div', {
    staticClass: "relative"
  }, [_vm.button ? _c('label', {
    staticClass: "label absolute right-0 p-3 cursor-pointer shadow-border-l mdmax:text-xs",
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.button))]) : _vm._e(), _c('div', {
    staticClass: "input pl-3 pr-24 py-3 focus:outline-none focus:ring focus:ring-primary-500 border border-neutral-300 w-full rounded-lg text-neutral-300 mdmax:text-xs"
  }, [_vm._v(_vm._s(_vm.selectedImage))]), _c('input', {
    staticClass: "absolute -z-1 opacity-0",
    attrs: {
      "type": "file",
      "id": _vm.id,
      "accept": _vm.accept
    },
    on: {
      "change": function ($event) {
        return _vm.selectFile($event);
      }
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }